import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { BellIcon } from './Icons';

const Header = ({ breadcrumbs = [] }) => {
  const { profile } = useAuth();

  const initials = profile?.full_name
    ? profile.full_name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase()
    : profile?.email?.[0]?.toUpperCase() || 'U';

  const displayName = profile?.full_name?.split(' ')[0] || profile?.email || 'User';

  return (
    <div
      className="bg-white rounded-3xl flex items-center justify-between gap-2 min-w-0 px-4 py-[14px]"
      style={{ boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.04)' }}
    >
      {/* Breadcrumbs */}
      <div className="flex items-center gap-1 min-w-0 flex-1 overflow-x-auto scrollbar-hide">
        {breadcrumbs.map((crumb, i) => (
          <React.Fragment key={i}>
            {i > 0 && (
              <span className="text-[14px] text-[rgba(28,28,28,0.2)] select-none flex-shrink-0">/</span>
            )}
            {crumb.href ? (
              <Link
                to={crumb.href}
                className="text-[14px] font-normal text-[rgba(28,28,28,0.4)] hover:text-[#3b3b3b] transition-colors px-2 py-1 rounded-lg flex-shrink-0"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className="text-[14px] font-medium text-[#3b3b3b] px-2 py-1 rounded-lg truncate min-w-0">
                {crumb.label}
              </span>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Right: Bell + User */}
      <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
        <button className="text-[#3b3b3b] hover:text-[#3fb5d2] transition-colors">
          <BellIcon />
        </button>
        <div className="flex items-center gap-2 pl-1 pr-2 py-1 rounded-lg hover:bg-gray-50 transition-colors">
          <div
            className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ background: '#3fb5d2' }}
          >
            <span className="text-white text-[10px] font-semibold leading-none">{initials}</span>
          </div>
          <span className="text-[12px] text-[#1c1c1c] font-normal max-w-[100px] sm:max-w-none truncate">{displayName}</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
